<div class="text-center mb-3">
	<h1 class="mb-0">WinFactor to FactorCloud Conversion</h1>
</div>
<div class="col-lg-12 mb-3" *ngIf="!showRemoved">
	<ul class="nav nav-tabs conversion-part-tabs">
		<li class="nav-item" *ngIf="showPartTabs">
			<a
				class="nav-link clickable"
				[ngClass]="view === 1 ? 'active' : ''"
				role="button"
				title="Carriers that still need Part 1 (steps 1-11): client, client doNotBill, client ACH and wire fees, missing debtors, client and debtor contacts, relationships, client notes, customer notes, client documents and customer documents."
				(click)="setView(1)"
				data-testid="conversion-tab-part1">
				<span class="conversion-part-step">1</span>
				Part 1 - Not Started
				<span class="badge conversion-part-count">{{ part1Count }}</span>
			</a>
		</li>
		<li class="nav-item" *ngIf="showPartTabs">
			<a
				class="nav-link clickable"
				[ngClass]="view === 2 ? 'active' : ''"
				role="button"
				title="Carriers through Part 1. Import their invoices into FactorCloud, then run Part 2."
				(click)="setView(2)"
				data-testid="conversion-tab-part2">
				<span class="conversion-part-step">2</span>
				Part 2 - Awaiting Invoices
				<span class="badge conversion-part-count">{{ part2Count }}</span>
			</a>
		</li>
		<li class="nav-item">
			<a
				class="nav-link clickable"
				[ngClass]="view === 4 ? 'active' : ''"
				role="button"
				title="Run a carrier start to finish in one go: Part 1, every open invoice posted to FactorCloud through the API, then Part 2."
				(click)="setView(4)"
				data-testid="conversion-tab-full">
				<span class="conversion-part-step"><i class="fa-solid fa-forward"></i></span>
				Ready for Conversion
				<span class="badge conversion-part-count">{{ fullCount }}</span>
			</a>
		</li>
		<li class="nav-item">
			<a
				class="nav-link clickable"
				[ngClass]="view === 3 ? 'active' : ''"
				role="button"
				title="Carriers that finished converting. Reopen one to run it through again."
				(click)="setView(3)"
				data-testid="conversion-tab-converted">
				<span class="conversion-part-step"><i class="fa-solid fa-check"></i></span>
				Converted
				<span class="badge conversion-part-count">{{ convertedCount }}</span>
			</a>
		</li>
		<li class="nav-item">
			<a
				class="nav-link clickable"
				[ngClass]="view === 5 ? 'active' : ''"
				role="button"
				title="Every WinFactor carrier, converted or not. Rerun any of them through the full conversion, for example to add the AtoB funding instruction."
				(click)="setView(5)"
				data-testid="conversion-tab-all">
				<span class="conversion-part-step"><i class="fa-solid fa-list"></i></span>
				All Clients
				<span class="badge conversion-part-count">{{ allCount }}</span>
			</a>
		</li>
	</ul>
</div>
<div class="col-lg-12 d-flex justify-content-between align-items-center mb-3">
	<div class="d-flex align-items-center">
		<div class="conversion-filter mr-3">
			<input
				class="form-control placeholder"
				type="text"
				[(ngModel)]="clientNameFilter"
				(keyup)="updateFilter()"
				placeholder="Carrier Name..."
				data-testid="conversion-client-name-filter" />
		</div>
		<label class="mb-0 clickable">
			<input
				type="checkbox"
				[checked]="showRemoved"
				[disabled]="loadingIndicator || migrationRunning"
				(change)="toggleShowRemoved()"
				data-testid="conversion-show-archived" />
			Show archived carriers
		</label>
	</div>
	<div class="d-flex flex-column align-items-end">
		<div class="d-flex align-items-center">
			<button
				type="button"
				title="Refresh Conversion List"
				class="btn btn-primary btn-round mr-2"
				[disabled]="loadingIndicator"
				(click)="loadConversionClients()"
				data-testid="conversion-refresh">
				<i class="fa-solid fa-rotate-right"></i>
			</button>
			<button
				type="button"
				title="Export the carriers in the grid (this tab and filters) to CSV"
				class="btn btn-outline-primary mr-2"
				[disabled]="loadingIndicator || filteredRows.length === 0"
				(click)="exportGrid()"
				data-testid="conversion-export">
				<i class="fa-solid fa-file-csv mr-1"></i>
				Export
			</button>
			<button
				*ngIf="view === 1"
				type="button"
				class="btn btn-primary"
				title="Steps 1-6: client, missing debtors, relationships, client notes, documents and the $0 first-fund-date invoice. Invoices are imported by hand afterwards."
				[disabled]="loadingIndicator || migrationRunning || showRemoved || part1SelectedRows.length === 0"
				(click)="migrateSelected(1)"
				data-testid="conversion-migrate-part1">
				Run Part 1
				<span *ngIf="part1SelectedRows.length > 0">({{ part1SelectedRows.length }})</span>
			</button>
			<button
				*ngIf="view === 2"
				type="button"
				class="btn btn-primary"
				title="Steps 7-11, after the invoices were imported into FactorCloud: match them, add invoice notes, reset the default funding instruction, update the client dates and balance, deactivate the WinFactor carrier and mark it converted."
				[disabled]="loadingIndicator || migrationRunning || showRemoved || part2SelectedRows.length === 0"
				(click)="migrateSelected(2)"
				data-testid="conversion-migrate-part2">
				Run Part 2
				<span *ngIf="part2SelectedRows.length > 0">({{ part2SelectedRows.length }})</span>
			</button>
			<button
				*ngIf="view === 4"
				type="button"
				class="btn btn-primary"
				title="Steps 1-11 in one run: client, debtors, relationships, client notes, documents, $0 invoice, every open invoice posted at its current balance, invoice notes, default funding instruction, client dates and balance, deactivate."
				[disabled]="loadingIndicator || migrationRunning || showRemoved || selectedCount === 0"
				(click)="migrateSelected(3)"
				data-testid="conversion-migrate-full">
				Run Full Conversion
				<span *ngIf="selectedCount > 0">({{ selectedCount }})</span>
			</button>
			<button
				*ngIf="view === 5 && !showRemoved"
				type="button"
				class="btn btn-primary"
				title="Run the full conversion again for the selected carriers. Converted carriers are reopened first; everything already in FactorCloud is reused and only what is missing (such as the AtoB funding instruction) is added."
				[disabled]="loadingIndicator || migrationRunning || reopenRunning || selectedCount === 0"
				(click)="rerunSelected()"
				data-testid="conversion-rerun-all">
				Rerun Full Conversion
				<span *ngIf="selectedCount > 0">({{ selectedCount }})</span>
			</button>
			<button
				*ngIf="view === 3 && !showRemoved"
				type="button"
				class="btn btn-outline-primary mr-2"
				title="Send back to the Part 1 tab to run both parts again. Notes are only added where FactorCloud has none."
				[disabled]="loadingIndicator || reopenRunning || selectedCount === 0"
				(click)="reopenSelected(1)"
				data-testid="conversion-reopen-part1">
				Reopen to Part 1
				<span *ngIf="selectedCount > 0">({{ selectedCount }})</span>
			</button>
			<button
				*ngIf="view === 3 && !showRemoved"
				type="button"
				class="btn btn-outline-primary"
				title="Send back to the Part 2 tab to run Part 2 again. Notes are only added where FactorCloud has none."
				[disabled]="loadingIndicator || reopenRunning || selectedCount === 0"
				(click)="reopenSelected(2)"
				data-testid="conversion-reopen-part2">
				Reopen to Part 2
				<span *ngIf="selectedCount > 0">({{ selectedCount }})</span>
			</button>
			<span *ngIf="migrationRunning" class="ml-2 text-muted" data-testid="conversion-migration-counter">
				<i class="fa-solid fa-spinner fa-spin"></i>
				{{ migrationCompleted }} / {{ migrationTotal }}
			</span>
		</div>
		<small class="text-muted mt-1"
			>{{ filteredRows.length }} carrier(s)
			{{ showRemoved ? 'archived' : view === 5 ? 'in all' : view === 4 ? 'not yet converted' : view === 3 ? 'converted' : view === 2 ? 'awaiting invoice import and Part 2' : 'waiting for Part 1' }}</small
		>
	</div>
</div>
<div class="col-lg-12 mb-3" *ngIf="!showRemoved && view !== 3" data-testid="conversion-bulk-steps">
	<div class="card">
		<div class="card-header d-flex justify-content-between align-items-center py-2">
			<strong>Bulk steps <small class="text-muted font-weight-normal">- run one step for every carrier on the conversion list</small></strong>
			<label
				class="mb-0 clickable small text-nowrap"
				title="A bulk step stops after the first carrier it fails for, so the problem can be fixed before going on.">
				<input
					type="checkbox"
					[(ngModel)]="stopImportOnFailure"
					[disabled]="bulkRunning"
					data-testid="conversion-bulk-stop-on-failure" />
				Stop at first failure
			</label>
			<label
				class="mb-0 ml-3 clickable small text-nowrap"
				title="Off: what already succeeded (since the app last started) is left out, so a re-run only does what is still to do. A bulk step leaves out the carriers it already did; a carrier's own run or batch leaves out the steps the carrier already did. On: everything runs again.">
				<input
					type="checkbox"
					[(ngModel)]="includeCompletedCarriers"
					[disabled]="bulkRunning"
					data-testid="conversion-bulk-include-completed" />
				Re-run what's already done
			</label>
		</div>
		<div class="card-body py-2 d-flex flex-wrap">
			<button
				*ngFor="let bulk of bulkSteps"
				type="button"
				class="btn btn-sm mr-2 mb-2"
				[ngClass]="isBulkStepRun(bulk.step) ? 'btn-primary' : 'btn-outline-primary'"
				[title]="bulk.hint"
				[disabled]="bulkRunning || migrationRunning || loadingIndicator"
				(click)="startBulkStep(bulk.step)"
				[attr.data-testid]="'conversion-bulk-step-' + bulk.step">
				<i *ngIf="bulkRunning && bulkStep === bulk.step" class="fa-solid fa-spinner fa-spin mr-1"></i>
				{{ bulk.step }}. {{ bulk.label }}
			</button>
		</div>
	</div>
</div>
<div class="col-lg-12 mb-3" *ngIf="migrationRunning" data-testid="conversion-migration-running">
	<div class="card conversion-migration-running">
		<div class="card-body py-2">
			<div class="d-flex justify-content-between align-items-center mb-1">
				<div>
					<i class="fa-solid fa-spinner fa-spin mr-2"></i>
					<strong>Running {{ partLabel(migrationPart) }}</strong>
					&mdash; carrier {{ migrationCompleted + 1 > migrationTotal ? migrationTotal : migrationCompleted + 1 }}
					of {{ migrationTotal }}: <strong>{{ migrationCurrentName }}</strong>
				</div>
				<small class="text-muted">Do not close or refresh this page until it finishes.</small>
			</div>
			<div class="text-primary small mb-1" data-testid="conversion-migration-activity">
				{{ migrationActivity }}
			</div>
			<div class="progress conversion-migration-running-bar">
				<div
					class="progress-bar progress-bar-striped progress-bar-animated"
					role="progressbar"
					[style.width.%]="migrationPercent">
					{{ migrationCompleted }} / {{ migrationTotal }} carrier(s) done
				</div>
			</div>
		</div>
	</div>
</div>
<div class="col-lg-12 mb-3" *ngIf="showBulkProgress" data-testid="conversion-bulk-progress">
	<div class="card">
		<div class="card-header d-flex justify-content-between align-items-center">
			<strong>{{ bulkStepLabel(bulkStep) }} (every carrier on the list)</strong>
			<div>
				<button
					*ngIf="bulkRunning"
					type="button"
					class="btn btn-sm btn-outline-danger mr-3"
					[disabled]="stoppingBulk || !bulkRunId"
					(click)="stopBulkStep()"
					data-testid="conversion-bulk-stop">
					<i class="fa-solid" [ngClass]="stoppingBulk ? 'fa-spinner fa-spin' : 'fa-stop'"></i>
					{{ stoppingBulk ? 'Stopping...' : 'Stop' }}
				</button>
				<button
					*ngIf="bulkProgress && bulkProgress.exceptions.length > 0"
					type="button"
					class="btn btn-link p-0 mr-3"
					(click)="downloadBulkExceptions()"
					data-testid="conversion-bulk-download-exceptions">
					<i class="fa-solid fa-download mr-1"></i>Download exceptions ({{ bulkProgress.exceptions.length }})
				</button>
				<button
					*ngIf="bulkProgress && bulkProgress.skippedNegativeInvoices.length > 0"
					type="button"
					class="btn btn-link p-0 mr-3"
					(click)="downloadBulkSkippedInvoices()"
					data-testid="conversion-bulk-download-negative">
					<i class="fa-solid fa-download mr-1"></i>Download skipped negative invoices ({{ bulkProgress.skippedNegativeInvoices.length }})
				</button>
				<ng-container *ngIf="bulkProgress && bulkProgress.invoiceImportErrorFiles">
					<button
						*ngFor="let errorFile of bulkProgress.invoiceImportErrorFiles; let errorFileIndex = index"
						type="button"
						class="btn btn-link p-0 mr-3"
						[ngClass]="isSummaryFile(errorFile) ? '' : 'text-danger'"
						[disabled]="downloadingBulkErrorFile === errorFile"
						(click)="downloadBulkInvoiceImportErrors(errorFile)"
						[attr.data-testid]="'conversion-bulk-download-invoice-import-errors-' + errorFileIndex">
						<i class="fa-solid mr-1" [ngClass]="downloadingBulkErrorFile === errorFile ? 'fa-spinner fa-spin' : 'fa-download'"></i>Download
						{{ invoiceFileLabel(errorFile) }} ({{ errorFile }})
					</button>
				</ng-container>
				<button
					*ngIf="!bulkRunning"
					type="button"
					class="btn btn-link p-0"
					(click)="showBulkProgress = false"
					data-testid="conversion-bulk-dismiss">
					Dismiss
				</button>
			</div>
		</div>
		<div class="card-body">
			<div *ngIf="!bulkProgress" class="text-muted"><i class="fa-solid fa-spinner fa-spin"></i> Starting...</div>
			<ng-container *ngIf="bulkProgress">
				<div class="progress mb-2" *ngIf="!bulkProgress.isComplete">
					<div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [style.width.%]="bulkPercent">
						<ng-container *ngIf="bulkShowsPrep">{{ bulkProgress.prepCompleted }} / {{ bulkProgress.prepTotal }} {{ bulkProgress.prepLabel }}</ng-container>
						<ng-container *ngIf="!bulkShowsPrep">{{ bulkProgress.completed }} / {{ bulkProgress.total }} carrier(s)</ng-container>
					</div>
				</div>
				<div class="text-muted mb-2" *ngIf="!bulkProgress.isComplete" data-testid="conversion-bulk-activity">{{ bulkProgress.activity }}</div>
				<div class="small text-muted mb-1" *ngIf="bulkRanFor" data-testid="conversion-bulk-ran-for">
					Started {{ utc(bulkProgress.startedOn) | date: 'short' }} &middot; {{ bulkProgress.isComplete ? 'Ran for' : 'Running for' }} <strong>{{ bulkRanFor }}</strong>
				</div>
				<div
					class="mb-2"
					*ngIf="bulkProgress.isComplete"
					[ngClass]="bulkProgress.errorMessage || bulkProgress.stopped || bulkProgress.failures.length > 0 ? 'text-warning' : 'text-success'">
					<strong>{{ bulkProgress.summary }}</strong>
				</div>
				<div class="small mb-1" *ngIf="bulkProgress.debtorSummary" data-testid="conversion-bulk-debtor-summary">{{ bulkProgress.debtorSummary }}</div>
				<div class="small mb-1" *ngIf="bulkProgress.invoiceImportSummary" data-testid="conversion-bulk-invoice-import-summary">{{ bulkProgress.invoiceImportSummary }}</div>
				<div class="small">
					Succeeded: {{ bulkProgress.succeeded }} &middot; Skipped: {{ bulkProgress.skipped.length }} &middot;
					Failed: {{ bulkProgress.failures.length }} &middot; Exceptions: {{ bulkProgress.exceptions.length }}
					<ng-container *ngIf="bulkProgress.alreadyDone > 0"> &middot; Already done (left out): {{ bulkProgress.alreadyDone }}</ng-container>
				</div>
				<div class="mt-2" *ngIf="bulkProgress.failures.length > 0">
					<div class="text-danger font-weight-bold">Failures ({{ bulkProgress.failures.length }})</div>
					<ul class="mb-0 small">
						<li *ngFor="let failure of bulkProgress.failures">{{ failure }}</li>
					</ul>
				</div>
				<div class="mt-2" *ngIf="bulkProgress.skipped.length > 0">
					<div class="text-muted font-weight-bold">Skipped ({{ bulkProgress.skipped.length }})</div>
					<ul class="mb-0 small text-muted">
						<li *ngFor="let skippedCarrier of bulkProgress.skipped">{{ skippedCarrier }}</li>
					</ul>
				</div>
			</ng-container>
		</div>
	</div>
</div>
<div class="col-lg-12" *ngIf="showMigrationResults" data-testid="conversion-migration-results">
	<div>
		<div class="card mb-3 conversion-migration-results">
			<div class="card-header d-flex justify-content-between align-items-center">
				<strong>Migration Results<span class="font-weight-normal text-muted" *ngIf="migrationRanFor"> &middot; ran for {{ migrationRanFor }}</span></strong>
				<div>
					<button
						*ngIf="invoiceSummaryRows().length > 0"
						type="button"
						class="btn btn-link p-0 mr-3"
						(click)="downloadInvoiceSummary()"
						data-testid="conversion-migration-results-download-invoice-summary">
						<i class="fa-solid fa-download mr-1"></i>Download invoice summary
					</button>
					<button
						*ngIf="skippedInvoices().length > 0"
						type="button"
						class="btn btn-link p-0 mr-3"
						(click)="downloadSkippedInvoices()"
						data-testid="conversion-migration-results-download-negative">
						<i class="fa-solid fa-download mr-1"></i>Download skipped negative invoices ({{ skippedInvoices().length }})
					</button>
					<button
						*ngIf="exceptions().length > 0"
						type="button"
						class="btn btn-link p-0 mr-3"
						(click)="downloadExceptions()"
						data-testid="conversion-migration-results-download-exceptions">
						<i class="fa-solid fa-download mr-1"></i>Download exceptions ({{ exceptions().length }})
					</button>
					<button
						type="button"
						class="btn btn-link p-0"
						(click)="dismissMigrationResults()"
						data-testid="conversion-migration-results-dismiss">
						Dismiss
					</button>
				</div>
			</div>
			<div class="card-body">
				<div
					*ngFor="let result of migrationResults; let resultIndex = index"
					class="mb-3"
					[attr.data-testid]="'conversion-migration-result-' + resultIndex">
					<div [ngClass]="migrationResultClass(result)">
						<strong>{{ result.clientName }}</strong> &mdash; {{ result.summary }}
					</div>
					<div class="mt-1" *ngIf="invoiceSummaryRows(result).length > 0">
						<button
							type="button"
							class="btn btn-sm btn-outline-secondary"
							(click)="downloadInvoiceSummary(result)"
							[attr.data-testid]="'conversion-migration-result-download-invoice-summary-' + resultIndex">
							<i class="fa-solid fa-download mr-1"></i>Download invoice summary
						</button>
					</div>
					<div class="mt-1" *ngIf="exceptions(result).length > 0">
						<button
							type="button"
							class="btn btn-sm btn-outline-secondary"
							(click)="downloadExceptions(result)"
							[attr.data-testid]="'conversion-migration-result-download-exceptions-' + resultIndex">
							<i class="fa-solid fa-download mr-1"></i>Download {{ exceptions(result).length }} exception(s)
						</button>
					</div>
					<div class="mt-1" *ngIf="skippedInvoices(result).length > 0">
						<button
							type="button"
							class="btn btn-sm btn-outline-secondary"
							(click)="downloadSkippedInvoices(result)"
							[attr.data-testid]="'conversion-migration-result-download-negative-' + resultIndex">
							<i class="fa-solid fa-download mr-1"></i>Download {{ skippedInvoices(result).length }} skipped negative invoice(s)
						</button>
					</div>
					<table class="table table-sm mb-0" *ngIf="result.steps && result.steps.length > 0">
						<thead>
							<tr>
								<th class="text-center" style="width: 50px">Step</th>
								<th style="width: 320px">Action</th>
								<th class="text-center" style="width: 90px">Status</th>
								<th>Detail</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let step of result.steps">
								<td class="text-center">{{ step.step }}</td>
								<td>{{ step.action }}</td>
								<td class="text-center" [ngClass]="migrationStepClass(step)">{{ step.status }}</td>
								<td class="conversion-step-detail">
									<div class="conversion-step-note" *ngFor="let line of detailLines(step.detail)">{{ line }}</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
<div>
	<div class="col-lg-12">
		<ngx-datatable
			#table
			class="material striped"
			[rows]="filteredRows"
			style="height: calc(72vh)"
			[loadingIndicator]="loadingIndicator"
			[columnMode]="columnMode.force"
			[headerHeight]="50"
			[footerHeight]="0"
			[scrollbarH]="true"
			[rowHeight]="40"
			[scrollbarV]="true">
			<ngx-datatable-column
				name=""
				prop="selected"
				[width]="40"
				[maxWidth]="60"
				[sortable]="false"
				[canAutoResize]="false"
				cellClass="text-center"
				headerClass="text-center">
				<ng-template ngx-datatable-header-template>
					<input
						type="checkbox"
						title="Select All"
						[checked]="allSelected()"
						[disabled]="migrationRunning || showRemoved"
						(change)="toggleSelectAll()"
						data-testid="conversion-select-all" />
				</ng-template>
				<ng-template
					ngx-datatable-cell-template
					let-row="row"
					let-rowIndex="rowIndex">
					<!--
						ngx-datatable 11 reuses row elements by position, so after the selected
						carriers move to the top a slot can keep the previous carrier's ticked
						checkbox. Looping over [row] (tracked by identity) throws the checkbox away
						and builds a fresh one whenever a different carrier lands in the slot, so its
						ticked state always comes from row.selected, never from the old element.
					-->
					<ng-container *ngFor="let slotRow of [row]; let slotIndex = index">
						<input
							type="checkbox"
							[checked]="slotRow.selected"
							[disabled]="migrationRunning || showRemoved"
							(change)="toggleRow(slotRow)"
							[attr.data-testid]="'conversion-select-row-' + rowIndex + '-' + slotIndex" />
					</ng-container>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column
				name="Carrier Name"
				prop="clientName"
				[width]="260"
				[sortable]="true"
				cellClass="text-left"
				headerClass="text-left">
			</ngx-datatable-column>

			<ngx-datatable-column
				name="Client #"
				prop="clientNos"
				[width]="90"
				[sortable]="true"
				cellClass="text-center"
				headerClass="text-center">
			</ngx-datatable-column>

			<ngx-datatable-column
				name="WinFactor ID"
				prop="winFactorIds"
				[width]="90"
				[sortable]="true"
				cellClass="text-center"
				headerClass="text-center">
			</ngx-datatable-column>

			<ngx-datatable-column
				name="Term"
				prop="termName"
				[width]="190"
				[sortable]="true"
				cellClass="text-left"
				headerClass="text-left">
				<ng-template ngx-datatable-cell-template let-value="value">
					<span
						[ngClass]="value === 'NO TERMS' ? 'text-warning font-weight-bold' : value && value !== 'NEW SYSTEM TRANSFER' ? 'font-weight-bold' : ''"
						[attr.title]="value === 'NO TERMS' ? 'No row in FactorCloud.TermsLookup; the conversion uses NEW SYSTEM TRANSFER.' : value">
						{{ value }}
					</span>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column
				name="Brokers"
				prop="debtorCount"
				[width]="70"
				[sortable]="true"
				cellClass="text-center"
				headerClass="text-center">
			</ngx-datatable-column>

			<ngx-datatable-column
				name="Missing in FC"
				prop="missingDebtorCount"
				[width]="90"
				[sortable]="true"
				cellClass="text-center"
				headerClass="text-center">
				<ng-template ngx-datatable-cell-template let-value="value">
					<span [ngClass]="value > 0 ? 'text-warning font-weight-bold' : ''">
						{{ value }}
					</span>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column
				name="Invoices"
				prop="invoiceCount"
				[width]="70"
				[sortable]="true"
				cellClass="text-center"
				headerClass="text-center">
			</ngx-datatable-column>

			<ngx-datatable-column
				name="Open Invoices"
				prop="openInvoiceCount"
				[width]="90"
				[sortable]="true"
				cellClass="text-center"
				headerClass="text-center">
			</ngx-datatable-column>

			<ngx-datatable-column
				name="Open Balance"
				prop="openInvoiceBalance"
				[width]="110"
				[sortable]="true"
				cellClass="text-right"
				headerClass="text-right">
				<ng-template ngx-datatable-cell-template let-value="value">
					{{ '$' }}{{ value | number: '1.2-2' }}
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column
				name="Status"
				prop="migrationStatus"
				[width]="150"
				[sortable]="false"
				cellClass="text-center"
				headerClass="text-center">
				<ng-template ngx-datatable-cell-template let-row="row">
					<i class="fa-solid fa-spinner fa-spin" *ngIf="row.migrating"></i>
					<span
						*ngIf="!row.migrating && row.migrationStatus"
						[ngClass]="migrationStatusClass(row)"
						[attr.title]="row.migrationSummary">
						{{ row.migrationStatus }}
					</span>
					<span
						*ngIf="!row.migrating && !row.migrationStatus && row.conversionCompletedDate"
						class="text-success font-weight-bold"
						[attr.title]="'Converted ' + (row.conversionCompletedDate | date: 'short') + (row.conversionReopenedDate ? ' (reopened before)' : '')">
						Converted
					</span>
					<span *ngIf="!row.migrating && !row.migrationStatus && !row.conversionPart1CompletedDate && !row.conversionCompletedDate" class="text-muted">
						{{ showRemoved ? 'Archived' : 'Not Started' }}
					</span>
					<span
						*ngIf="!row.migrating && !row.migrationStatus && row.conversionPart1CompletedDate && !row.conversionCompletedDate"
						class="text-primary"
						[attr.title]="'Part 1 finished ' + (row.conversionPart1CompletedDate | date: 'short') + '. Import the invoices into FactorCloud, then run Part 2.'">
						Awaiting Invoices
					</span>
				</ng-template>
			</ngx-datatable-column>

			<ngx-datatable-column
				name="Details"
				prop="details"
				[width]="150"
				[sortable]="false"
				cellClass="text-center"
				headerClass="text-center">
				<ng-template
					ngx-datatable-cell-template
					let-row="row"
					let-rowIndex="rowIndex">
					<button
						class="btn btn-primary py-0"
						(click)="openDetailModal(row)"
						[attr.data-testid]="'conversion-details-' + rowIndex">
						Details
					</button>
					<button
						*ngIf="!showRemoved && view !== 3 && !row.conversionCompletedDate"
						class="btn btn-outline-danger py-0 ml-1"
						title="Archive: take off the conversion list"
						[disabled]="migrationRunning || row.migrating"
						(click)="archiveRow(row)"
						[attr.data-testid]="'conversion-archive-' + rowIndex">
						Archive
					</button>
					<button
						*ngIf="showRemoved"
						class="btn btn-outline-primary py-0 ml-1"
						title="Put back on the conversion list"
						(click)="restoreRow(row)"
						[attr.data-testid]="'conversion-restore-' + rowIndex">
						Restore
					</button>
				</ng-template>
			</ngx-datatable-column>
		</ngx-datatable>
	</div>
</div>

<app-conversion-detail-modal></app-conversion-detail-modal>

<!-- Step 1 stopped on "The company code X is already registered": who has the code, and the option to re-code it. -->
<ng-template #CodeConflictModalTemplate>
	<div class="modal-content" data-testid="conversion-code-conflict-modal">
		<div class="modal-header">
			<h4 class="modal-title">
				<i class="fa-solid fa-triangle-exclamation text-warning mr-2"></i>Company Code {{ codeConflict?.code }} Is Already Used
			</h4>
		</div>
		<div class="modal-body">
			<p>
				<strong>{{ codeConflictClientName }}</strong> could not be created in FactorCloud because code
				<strong>{{ codeConflict?.code }}</strong> already belongs to:
			</p>
			<table class="table table-sm mb-3">
				<thead>
					<tr>
						<th>Company</th>
						<th>Type</th>
						<th>Status</th>
						<th>FactorCloud ID</th>
					</tr>
				</thead>
				<tbody>
					<tr
						*ngFor="let owner of codeConflict?.owners; let ownerIndex = index"
						[attr.data-testid]="'conversion-code-conflict-owner-' + ownerIndex">
						<td><strong>{{ owner.companyName }}</strong></td>
						<td class="text-capitalize">{{ owner.companyType }}</td>
						<td>{{ owner.active === false ? 'Inactive' : 'Active' }}</td>
						<td>{{ owner.id }}</td>
					</tr>
				</tbody>
			</table>
			<p *ngIf="codeConflictOwner" class="mb-0">
				Change <strong>{{ codeConflictOwner.companyName }}</strong> to code
				<strong>{{ codeConflict?.newCode }}</strong> so {{ codeConflictClientName }} can be created with
				code {{ codeConflict?.code }}? The carrier is run again straight after.
			</p>
			<p *ngIf="!codeConflictOwner" class="mb-0 text-muted">
				More than one company has this code, so it cannot be changed from here. Fix it in FactorCloud, then run
				the carrier again.
			</p>
			<div *ngIf="recodeError" class="alert alert-danger mt-3 mb-0" data-testid="conversion-code-conflict-error">
				{{ recodeError }}
			</div>
		</div>
		<div class="modal-footer">
			<button
				type="button"
				class="btn btn-outline-secondary"
				[disabled]="recodeRunning"
				(click)="closeCodeConflict(false)"
				data-testid="conversion-code-conflict-skip">
				Skip This Carrier
			</button>
			<button
				*ngIf="codeConflictOwner"
				type="button"
				class="btn btn-primary"
				[disabled]="recodeRunning"
				(click)="recodeConflictOwner()"
				data-testid="conversion-code-conflict-recode">
				<i *ngIf="recodeRunning" class="fa-solid fa-spinner fa-spin mr-1"></i>
				Change Code to {{ codeConflict?.newCode }} and Retry
			</button>
		</div>
	</div>
</ng-template>
<app-migration-progress-modal></app-migration-progress-modal>



// WEBPACK FOOTER //
// ./src/app/portal/conversion/conversion.component.html